import React from 'react';
import { ArrowUpRight, MapPin } from 'lucide-react';
import { FOUNDERS } from '../content';
import { SCENE_IMG } from '../media';
export function Founders() {
  return <section id="founders" className="border-t border-border bg-card" aria-labelledby="founders-heading" data-id="element-24" data-mp="1647av1ag6dkl">
      <div className="section-shell py-16 lg:py-20" data-id="element-25" data-mp="115ctm3s4ox2l">
        {/* Headline beside the coast, mirroring the basecamp section. */}
        <div className="grid items-center gap-8 lg:grid-cols-[1.1fr_0.9fr] lg:gap-14" data-id="element-26" data-mp="w71jrt1u2mkd">
          <div data-id="element-27" data-mp="rerp5zprwybr">
            <p className="overline" data-id="element-28" data-mp="re8d2zmt145n">On the trail</p>
            <h2 id="founders-heading" className="mt-5 font-serif text-h3 lg:text-h2" data-id="element-29" data-mp="ndpk3296ds1v">
              Founders we&rsquo;ve worked with
            </h2>
          </div>
          <figure className="m-0 overflow-hidden rounded-lg" data-id="element-30" data-mp="ig67s7w1fpck">
            <img src={SCENE_IMG.californiaCoast} alt="Waves breaking on dark rock along the California coast" loading="lazy" className="block h-56 w-full object-cover object-center lg:h-72" data-id="element-31" data-mp="dfrx0i31y1au" />
          </figure>
        </div>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-32" data-mp="825una3e0rvy">
          {FOUNDERS.map(f => <li key={f.company} className="flex flex-col rounded-lg border border-border bg-background p-6" data-id="element-33" data-mp="3pix5tgm9oyix">
              {/* Co-founders overlap slightly so the pair reads as one team. */}
              <div className="flex" data-id="element-34" data-mp="m0vtau5uuzmf">
                {f.photos.map((p, i) => <span key={p.name} className={`block h-20 w-20 overflow-hidden rounded-full bg-secondary ring-4 ring-background ${i > 0 ? '-ml-4' : ''}`} data-id="element-35" data-mp="r0i7p6xf6lwt" data-mpi={i}>
                    <img src={p.src} alt={p.name} loading="lazy" className={`h-full w-full object-cover object-top ${p.zoom ? 'scale-125' : ''}`} data-id="element-36" data-mp="h0hhd114v5j4" />
                  </span>)}
              </div>

              <h3 className="mt-5 font-serif text-h4 leading-snug" data-id="element-37" data-mp="18bx7i5gj4tyy">
                {f.url ? <a href={f.url} target="_blank" rel="noopener noreferrer" className="group inline underline decoration-border-strong decoration-1 underline-offset-4 transition-colors hover:text-primary hover:decoration-current" data-id="element-38" data-mp="13cu7izfepdxu">
                    {f.company}
                    <ArrowUpRight size={16} aria-hidden="true" className="ml-1 inline-block align-baseline opacity-60 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:opacity-100" data-id="element-39" data-mp="kjgn3o9bkpwh" />
                    <span className="sr-only" data-id="element-40" data-mp="29yo5q8y777sp"> (opens in a new tab)</span>
                  </a> : f.company}
              </h3>
              <p className="mt-2 text-body-sm font-semibold" data-id="element-41" data-mp="2ciku7mze89ht">{f.founders}</p>
              <p className="mt-1 flex items-center gap-1.5 text-caption text-muted-foreground" data-id="element-42" data-mp="2hi75vrzkphoi">
                <MapPin size={12} aria-hidden="true" data-id="element-43" data-mp="2m9p448a7p45s" />
                {f.location}
              </p>
              <p className="mt-4 text-body-sm leading-body text-muted-foreground" data-id="element-44" data-mp="2r91swykn8lb0">{f.line}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}